import { Outlet } from 'react-router-dom'

import { ErrorBoundary } from './ErrorBoundary.js'
import { Navigation } from './Navigation.js'
import styles from './AppShell.module.css'

/**
 * The frame every screen sits in.
 *
 * The error boundary is inside the shell rather than around it, so a screen
 * that throws leaves the navigation intact and the user can move somewhere
 * else. A boundary at the root would replace the whole app with an error page
 * and leave no way out but a reload.
 */
export function AppShell() {
  return (
    <div className={styles['shell']}>
      <Navigation />
      <main className={styles['main']}>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  )
}
